import { LineItemText } from "components/formFields/LineItemText";
import { LineTableCell } from "components/formFields/LineTableCell";
import { DatePicker } from "components/html/Input/DatePicker";

import { formatDate } from "services/utility/dates";

const outlinedStyles = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderWidth: 0 },
    "& input": { paddingTop: "0", paddingBottom: "0" },
  },
};

export function LineDueDate(props) {
  const { value, onValueChange, error, lineReadOnly = false } = props;

  if (lineReadOnly) {
    return (
      <LineTableCell sx={{ fontSize: "0.8125rem", padding: "0.5rem 0.7rem" }}>
        <LineItemText value={value instanceof Date ? formatDate(value) : ""} />
      </LineTableCell>
    );
  }

  return (
    <LineTableCell sx={{ minWidth: "10rem" }}>
      <DatePicker
        key={value}
        name="duedate"
        value={value instanceof Date ? value : null}
        onValueChange={onValueChange}
        textSx={outlinedStyles}
        dataTesting="duedate"
        error={error}
      />
    </LineTableCell>
  );
}
